const userStore = {
  state: {
    user: {
      name: '',
      email: '',
      token: '',
    },
  },
  getters: {
    isUser(state) {
      return state.user;
    },
  },
  mutations: {
    UPDATE_USER(state, payload) {
      state.user = payload;
    },
  },
};

export default userStore;
